<template>
  <div class="join-club">
    <div v-if="joinInfo" class="join-form">
      <!--<ul v-if="classJoinType" class="input-div">
        <li class="title" style="padding-bottom: 0; text-align: center;">나주 대신송촌 리틀드래곤즈 입단 신청서입니다.</li>
      </ul>-->
      <ul class="input-div">
        <li class="title">클래스</li>
        <li>
          <div class="li-flex">
            <div class="radio pr-45">
              <input type="radio" name="classType" id="individual" v-model="classType" value="individual" class="select-style" checked="checked" @change="changeClassType('individual')">
              <label class="radio-label pr" for="individual">리틀드래곤즈</label>
              <input type="radio" name="classType" id="team" v-model="classType" value="team" class="select-style" @change="changeClassType('team')">
              <label class="radio-label pr" for="team">리틀드래곤즈 팀(TEAM)</label>
              <input type="radio" name="classType" id="naju" v-model="classType" value="naju" class="select-style" @change="changeClassType('naju')">
              <label class="radio-label naju" for="naju">나주리틀드래곤즈</label>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="hasAvailableClass && (classType === 'naju' || (isUniformStockLoaded && !isUniformSoldOut))" class="form-input">
        <ul class="input-div">
          <li class="title">참가학생 이름</li>
          <li>
            <input type="text" class="input-style" v-model="info.child_name" placeholder="참가학생 이름을 입력하세요.">
          </li>
        </ul>
        <ul class="input-div">
          <li class="title">참가학생 생년월일</li>
          <li>
            <input type="text" class="input-style" v-model="info.child_birth" placeholder="참가학생 생년월일을 선택하세요." @click="showDatePicker = true" readonly>
            <v-date-picker v-if="showDatePicker" v-model="selectedDate" @input="onDateSelected" />
          </li>
        </ul>
        <ul class="input-div">
          <li class="title">
            참가학생 재학학교
          </li>
          <li>
            <input type="text" class="input-style" v-model="info.child_school" placeholder="참가학생 재학학교를 입력하세요.">
          </li>
          <li v-if="!classJoinType">
            <div class="checkbox-container">
              <input type="checkbox" id="checkbox" v-model="info.infants" class="custom-checkbox" :disabled="classJoinType">
              <label for="checkbox" class="custom-label">유치원생 여부</label>
            </div>
          </li>
        </ul>
        <ul class="input-div">
          <li class="title">보호자 성명</li>
          <li>
            <input type="text" class="input-style" v-model="info.parents_name" placeholder="보호자 성명을 입력하세요.">
          </li>
        </ul>
        <ul class="input-div">
          <li class="title">보호자 연락처</li>
          <li>
            <InputPhone v-model="info.parents_ph" :value="info.parents_ph" :label="'휴대폰번호를 입력하세요.'"/>
          </li>
        </ul>
        <ul class="input-div">
          <li class="title">주소</li>
          <li class="add-flex addr-cont">
            <input type="text" class="input-style" v-model="info.zipcode" placeholder="우편번호" @click="searchAddress" readonly>
            <button class="id-check" @click="searchAddress">우편번호 검색</button>
            <div class="zipcodeWrap" ref="embed"></div>
          </li>
          <li class="mt-12">
            <input type="text" class="input-style" v-model="info.address1" placeholder="주소를 입력하세요" readonly>
          </li>
          <li class="mt-12">
            <input type="text" class="input-style" v-model="info.address2" placeholder="상세 주소를 입력하세요">
          </li>
        </ul>
        <ul class="input-div">
          <li class="title">신청 클래스 선택</li>
          <li>
            <div v-if="!classJoinType" class="select-div">
              <select class="select-box" v-model="info.yoil" :class="{placeholder: isEmpty(info.yoil)}" :disabled="classJoinType">
                <option value="null" disabled hidden selected>
                  {{ classJoinType ? '선택할 수 없습니다.' : '요일을 선택하세요.'}}
                </option>
                <option v-if="satList.length > 0" value="토요일">토요일</option>
                <option v-if="sunList.length > 0" value="일요일">일요일</option>
              </select>
            </div>
            <div class="select-div">
              <select class="select-box" v-model="info.product_place_time" :class="{placeholder: isEmpty(info.product_place_time)}">
                <option value="null" disabled hidden selected>클래스를 선택하세요.</option>
                <option
                  v-for="(ver, i) in classList"
                  :key="i"
                  :value="ver.product_place_time"
                  :disabled="ver.disabledType">
                  {{ver.product_place_time}}
                </option>
              </select>
            </div>
            <div v-if="info.product_place_time === '자율구성'" class="select-div">
              <input type="text" class="input-style" v-model="info.shared_value" placeholder="공동 번호 세 자리" @input="info.shared_value = info.shared_value.replace(/[^0-9]/g, '').slice(0, 3)">
              <p>※ 팀 구성원 모두 같은 번호를 입력해야 같은 팀으로 확인됩니다.</p>
            </div>
            <div v-if="!classJoinType" class="select-div">
              <select class="select-box" v-model="info.uniform_size" :class="{placeholder: isEmpty(info.uniform_size)}" :disabled="classJoinType">
                <option value="null" disabled hidden selected>
                  {{ classJoinType ? '선택할 수 없습니다.' : '유니폼 사이즈를 선택하세요.'}}
                </option>
                <option
                  v-for="(ver, i) in uniformSize"
                  :key="i"
                  :value="ver.id"
                  :disabled="ver.disabledType">
                  {{ver.text}}
                </option>
              </select>
              <p v-if="!classJoinType" class="select-bottom">* 사이즈 교환 불가</p>
            </div>
          </li>
        </ul>
        <ul v-if="!classJoinType" class="input-div">
          <li class="title">희망 마킹 배번 <span>* 추후 변경 절대 불가</span></li>
          <li>
            <InputPhone :disabledType="classJoinType" :type="'markingNum'" v-model="info.uniform_number" :value="info.uniform_number" :label="'마킹 배번을 입력하세요.'" :dash-check="false" />
          </li>
        </ul>
        <ul v-if="!classJoinType" class="input-div">
          <li class="title">현금영수증 발행 여부</li>
          <li class="li-flex">
            <div class="radio pr-45">
              <input :disabled="classJoinType" type="radio" name="emailAgree" v-model="info.cash_receipt" value="Y" class="select-style" checked="checked">
              <label class="radio-label pr">예</label>
              <input :disabled="classJoinType" type="radio" name="emailAgree" v-model="info.cash_receipt" value="N" class="select-style">
              <label class="radio-label">아니요</label>
            </div>
          </li>
        </ul>
        <ul v-if="inputExposure" class="input-div">
          <li class="title">발행번호(휴대폰 번호)</li>
          <li>
            <InputPhone v-model="info.cash_receipt_number" :value="info.cash_receipt_number" :label="'발행번호를 입력하세요.'" />
          </li>
        </ul>
        <div class="agree-page">
          <div class="agree-div">
            <ul class="item-ul">
              <li class="first">
                <p class="title">개인정보 수집 및 이용에 대한 안내 (필수)</p>
              </li>
              <li class="second">
                <div class="right">
                  <input type="radio" name="'select_agree" class="select-style"
                         v-model="info.agree" value="Y">
                  <label class="radio-label pr">동의</label>
                  <input type="radio" name="'select_agree" class="select-style"
                         v-model="info.agree" value="N">
                  <label class="radio-label">미동의</label>
                </div>
              </li>
              <li class="area">
                <div class="text-area">
<pre>
(주)전남드래곤즈는 아래의 목적으로 개인정보를 수집 및 이용하며, 회원의 개인정보를 안전하게 취급하는데 최선을 다합니다.

1. 수집목적
• 리틀드래곤즈 수강생 모집 및 수업, 수강생관리, 민원처리
• 리틀드래곤즈 수강생 대상 유니폼, 츄리닝 배송, 관리

2. 수집항목
선수 성명, 선수 생년월일, 선수 재학학교, 선수 유치원생 여부, 보호자 성명, 보호자 연락처, 보호자 주소, 수업 구장, 수업 반, 유니폼 신청여부 및 사이즈, 츄리닝 신청여부 및 사이즈

3. 보유기간
• 차기 기수 리틀드래곤즈 수업 접수 개시 이후 지체없이 파기됩니다.
• 차기 기수 모집이 없을 경우 해당 기수 리틀드래곤즈 수업 종료 이후 지체없이 파기됩니다.
• 보호자, 선수, 전남드래곤즈의 사유에 따라 중도 수업을 종료 했을 때 지체없이 파기됩니다.
</pre>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 연회비 안내 (리틀드래곤즈) -->
        <div class="agree-page price" v-if="classType === 'individual'">
          <div class="agree-div">
            <ul class="item-ul">
              <li class="first">
                <p class="title">연회비 (필수)</p>
              </li>
              <li class="area">
                <div class="text-area w100">
<pre>
- 금액: 27만원
- 은행명: 농협은행
- 계좌번호: 355-0092-3084-83
- 예금주: (주) 전남드래곤즈
</pre>
                </div>
                <p style="margin-top: 10px">※ 연회비 입금 완료 시 신청이 최종 완료됩니다.</p>
              </li>
              <li class="agree-btm">
                <div class="right">
                  <input type="radio" name="'select_price_agree" class="select-style"
                         v-model="price_agree" value="Y" id="select_price_agree_y_individual">
                  <label class="radio-label pr" for="select_price_agree_y_individual">예</label>
                  <input type="radio" name="'select_price_agree" class="select-style"
                         v-model="price_agree" value="N" id="select_price_agree_n_individual">
                  <label class="radio-label" for="select_price_agree_n_individual">아니오</label>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 연회비 안내 (리틀드래곤즈 팀) -->
        <div class="agree-page price" v-else-if="classType === 'team'">
          <div class="agree-div">
            <ul class="item-ul">
              <li class="first">
                <p class="title">입단비 및 월회비 (필수)</p>
              </li>
              <li class="area">
                <div class="text-area w100">
<pre>
- 입단비: 5만원
- 월회비: 10만원
- 은행명: 농협은행
- 계좌번호: 355-0092-3084-83
- 예금주: (주) 전남드래곤즈
</pre>
                </div>
                <p style="margin-top: 10px">※ 입금 안내는 클래스 개강 확정 후 별도로 안내드리며, 선입금은 절대 금지입니다.</p>
              </li>
              <li class="agree-btm">
                <div class="right">
                  <input type="radio" name="'select_price_agree" class="select-style"
                         v-model="price_agree" value="Y" id="select_price_agree_y_team">
                  <label class="radio-label pr" for="select_price_agree_y_team">예</label>
                  <input type="radio" name="'select_price_agree" class="select-style"
                         v-model="price_agree" value="N" id="select_price_agree_n_team">
                  <label class="radio-label" for="select_price_agree_n_team">아니오</label>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 신청 버튼 추가 -->
        <div class="btn-div">
          <button class="login-btn" @click="classRegister">입단 신청</button>
        </div>
      </div>
      <div v-else>
        <PageComingSoon :titleText="'신청 마감'" :descriptionText="'해당 입단신청은 마감되었습니다.'" :descriptionTextSub="'추가 입단은 061-815-0132로 문의 바랍니다.'" />
      </div>
    </div>
    <div v-else class="page-coming-soon">
      <ul>
        <li class="logo-img">
          <img src="@/assets/img/dragons_logo.png" alt="dragons_logo">
        </li>
        <li class="logo-text">
          <img src="@/assets/img/logo_text.png" alt="logo_text">
        </li>
        <li>
          <p class="title">신청 안내</p>
        </li>
        <li class="pt">
          <p>2026년 2월 1일 10:00 TEAM 클래스 회원모집 오픈</p>
          <p>2026년 2월 2일 10:00 리틀드래곤즈 일반 클래스 회원 모집 오픈</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {isEmpty, isPwd, trim} from '@/lib';
import InputPhone from '@/components/Common/InputPhone.vue';
import PageComingSoon from '@/components/Common/PageComingSoon.vue';
import dayjs from 'dayjs';

export default {
  name: 'ApplicationJoinClub.vue',
  components: {InputPhone, PageComingSoon},
  props: ['routeName'],
  data() {
    return {
      classJoinType: false,
      joinInfo: true,
      selectedDate: '',
      showDatePicker: false,
      classType: 'individual',
      classData: {},
      info: {
        child_name: '',
        child_birth: '',
        child_school: '',
        infants: false,
        parents_name: '',
        parents_ph: '',
        zipcode: '',
        address1: '',
        address2: '',
        yoil: null,
        product_place_time: null,
        uniform: null,
        uniform_size: null,
        uniform_number: null,
        cash_receipt: '',
        cash_receipt_number: '',
        agree: '',
        shared_value: null
      },
      price_agree: '',
      classList: [],
      satList: [],
      sunList: [],
      uniformSize: [
        { id: '3XS', text: '3XS' },
        { id: '2XS', text: '2XS' },
        { id: 'XS', text: 'XS' },
        { id: 'S', text: 'S' },
        { id: 'M', text: 'M' },
      ],
      uniformList: {},
      hasAvailableClass: false,
      isUniformStockLoaded: false,
      isUniformSoldOut: true,
      inputExposure: false
    }
  },
  mounted () {
    this.init();
  },
  watch: {
    'info.yoil': function(newValue) {
      if(newValue === '토요일') {
        this.classList = this.satList;
      }else {
        this.classList = this.sunList;
      }
      this.info.product_place_time = null;
    },
    'info.cash_receipt': function(newValue) {
      this.inputExposure = newValue === 'Y';
    }
  },
  methods: {
    isEmpty,
    async init() {

      // 첫 번째 API 호출: 클래스 정보 가져오기
      const result = await this.$http.get('/little_dragons/check/class');

      this.classData = result.data.data;
      this.updateDataByType(this.classType);

      this.isUniformStockLoaded = false;
      this.isUniformSoldOut = true;

      if (this.classType === 'naju') {
        return;
      }

      try {
        const uniformResult = await this.$http.get('/little_dragons/check/uniform');
        const uniformData = uniformResult.data && uniformResult.data.data;
        const uniformStock = Array.isArray(uniformData) ? uniformData[0] : null;

        if (!this.isValidUniformStock(uniformStock)) {
          throw new Error('유니폼 재고 API 응답 형식이 올바르지 않습니다.');
        }

        this.uniformList = uniformStock;
        this.checkSizeAvailability('S', uniformStock.s_cnt, uniformStock.s_cnt_max);
        this.checkSizeAvailability('M', uniformStock.m_cnt, uniformStock.m_cnt_max);
        this.checkSizeAvailability('XS', uniformStock.xs_cnt, uniformStock.xs_cnt_max);
        this.checkSizeAvailability('2XS', uniformStock.two_xs_cnt, uniformStock.two_xs_cnt_max);
        this.checkSizeAvailability('3XS', uniformStock.three_xs_cnt, uniformStock.three_xs_cnt_max);
        this.isUniformSoldOut = this.uniformSize.every(size => size.disabledType);
        this.isUniformStockLoaded = true;
      } catch (error) {
        this.uniformList = {};
        const errorMessage = error && error.message ? error.message : '알 수 없는 오류';
        console.error('유니폼 재고 정보를 불러오지 못했습니다.', errorMessage);
      }
    },
    isValidUniformStock(uniformStock) {
      const requiredFields = [
        's_cnt', 's_cnt_max',
        'm_cnt', 'm_cnt_max',
        'xs_cnt', 'xs_cnt_max',
        'two_xs_cnt', 'two_xs_cnt_max',
        'three_xs_cnt', 'three_xs_cnt_max'
      ];

      return uniformStock && requiredFields.every(field => Number.isFinite(uniformStock[field]));
    },
    checkSizeAvailability(sizeId, count, maxCount) {
      const size = this.uniformSize.find(item => item.id === sizeId);
      if (size) {
        const isSoldOut = count >= maxCount;
        size.text = isSoldOut ? `${sizeId} (마감)` : sizeId;
        size.disabledType = isSoldOut;
      }
    },
    onDateSelected(date) {
      this.info.child_birth = dayjs(date).format('YYYY-MM-DD'); // 선택한 날짜를 info.child_birth에 저장
      this.showDatePicker = false; // 날짜 선택기 숨기기
    },
    searchAddress() {
      new window.kakao.Postcode({
        oncomplete: (data) => {
          this.info.zipcode = data.zonecode;
          this.info.address1 = data.address;
        }
      }).embed(this.$refs.embed);
    },
    updateDataByType(type) {
      const _data = this.classData.filter(item => item.class_type === type);
      this.hasAvailableClass = _data.some(item => item.apply_cnt < item.apply_max_cnt);
      this.satList = [];
      this.sunList = [];

      _data.forEach(product => {
        let { product_place_time, yoil, apply_cnt, apply_max_cnt } = product;
        product_place_time += apply_cnt >= apply_max_cnt ? ` (마감)` : ``;
        let disabledType = apply_cnt >= apply_max_cnt;

        this.classJoinType = product.class_place === '나주';

        if (!this.classJoinType) {
          if (yoil === '토요일') {
            this.satList.push({ product_place_time, disabledType });
          } else if (yoil === '일요일') {
            this.sunList.push({ product_place_time, disabledType });
          }
        } else {
          this.classList.push({ product_place_time, disabledType });
        }
      });
    },
    changeClassType(type) {
      this.classType = type;
      this.hasAvailableClass = false;
      this.price_agree = '';
      this.classList = [];
      this.info = {
        child_name: '',
        child_birth: '',
        child_school: '',
        infants: false,
        parents_name: '',
        parents_ph: '',
        zipcode: '',
        address1: '',
        address2: '',
        yoil: null,
        product_place_time: null,
        uniform: null,
        uniform_size: null,
        uniform_number: null,
        cash_receipt: '',
        cash_receipt_number: '',
        agree: '',
        shared_value: null
      };
      this.selectedDate = '';

      this.init();
    },
    validityCheck() {
      if(isEmpty(trim(this.info.child_name))) {
        alert('참가학생 이름을 입력하세요.');
        return false;
      }
      if(isEmpty(trim(this.info.child_birth))) {
        alert('참가학생 생년월일을 입력하세요.');
        return false;
      }
      if(isEmpty(trim(this.info.child_school))) {
        alert('참가학생 재학학교를 입력하세요.');
        return false;
      }
      if(isEmpty(trim(this.info.parents_name))) {
        alert('보호자 성명을 입력하세요.');
        return false;
      }
      if(isEmpty(trim(this.info.parents_ph))) {
        alert('보호자 연락처를 입력하세요.');
        return false;
      }
      if(isEmpty(trim(this.info.address1))) {
        alert('주소를 입력하세요.');
        return false;
      }
      if(isEmpty(trim(this.info.address2))) {
        alert('상세 주소를 입력하세요.');
        return false;
      }
      if(!this.classJoinType && (isEmpty(trim(this.info.yoil)) || this.info.yoil === null)) {
        alert('신청 요일을 선택하세요.');
        return false;
      }
      if(isEmpty(trim(this.info.product_place_time)) || this.info.product_place_time === null) {
        alert('신청 클래스를 선택하세요.');
        return false;
      }
      if(!this.classJoinType && (isEmpty(trim(this.info.uniform_size)) || this.info.uniform_size === null)) {
        alert('유니폼 사이즈를 선택하세요.');
        return false;
      }
      if(!this.classJoinType && (isEmpty(trim(this.info.uniform_number)) || this.info.uniform_number === null)) {
        alert('마킹 배번 선택하세요.');
        return false;
      }
      if(!this.classJoinType && isEmpty(trim(this.info.cash_receipt))) {
        alert('현금영수증 발행 여부를 선택하세요.');
        return false;
      }
      if(!this.classJoinType && this.info.cash_receipt === 'Y' && isEmpty(trim(this.info.cash_receipt_number))) {
        alert('현금영수증 발행번호를 입력하세요.');
        return false;
      }
      if(isEmpty(trim(this.info.agree)) || this.info.agree === 'N') {
        alert('필수 동의 사항에 동의해야 입단 신청이 가능합니다.');
        return false;
      }
      if(!this.classJoinType && (isEmpty(trim(this.price_agree)) || this.price_agree === 'N')) {
        alert('연회비 내용 확인에 동의하셔야 신청이 완료됩니다.');
        return false;
      }
      if(this.info.product_place_time === '자율구성' && (isEmpty(trim(this.info.shared_value)) || this.info.shared_value === null)) {
        alert('자율구성 공동 번호 세 자리를 입력하세요.');
        return false;
      }
      return true;
    },
    async classRegister() { // 입단 신청
      if (!this.validityCheck()) {
        return false;
      }

      this.info.parents_ph = this.info.parents_ph.replace(/-/g, '');

      if (this.classJoinType) {
        this.info.product_place = '나주';

        delete this.info.infants;
        delete this.info.yoil;
        delete this.info.uniform;
        delete this.info.uniform_size;
        delete this.info.uniform_number;
        delete this.info.cash_receipt;
        delete this.info.cash_receipt_number;
      } else {
        this.info.infants = this.info.infants ? 'Y' : 'N';
        this.info.uniform = !isEmpty(this.info.uniform_size) ? 'Y' : 'N';
        this.info.cash_receipt_number = this.info.cash_receipt_number.replace(/-/g, '');
      }

      const {data} = await this.$http.post('/little_dragons/apply', this.info);

      if (data.success) {
        if (this.classJoinType) {
          alert('입단 신청이 완료되었습니다.');
        } else {
          alert('신청 완료되었습니다.');
        }
        this.reset();
        window.scrollTo(0, 0);
      } else {
        if (data.message) {
          alert(data.message);
        } else {
          alert('입단 신청에 실패하였습니다.');
        }
      }
    },
    reset() {
      this.classData = {};
      this.price_agree = '';
      this.isUniformStockLoaded = false;
      this.isUniformSoldOut = true;
      this.info = {
        child_name: '',
        child_birth: '',
        child_school: '',
        infants: false,
        parents_name: '',
        parents_ph: '',
        zipcode: '',
        address1: '',
        address2: '',
        yoil: null,
        product_place_time: null,
        uniform: null,
        uniform_size: null,
        uniform_number: null,
        cash_receipt: '',
        cash_receipt_number: '',
        agree: '',
        shared_value: null
      };
      this.inputExposure = false;
      this.selectedDate = '';
      this.showDatePicker = false;
      this.uniformSize = [
        { id: '3XS', text: '3XS' },
        { id: '2XS', text: '2XS' },
        { id: 'XS', text: 'XS' },
        { id: 'S', text: 'S' },
        { id: 'M', text: 'M' },
      ];
      this.classList = [];
      this.satList = [];
      this.sunList = [];
      this.init();
    }
  }
}
</script>
<style lang="scss" scoped>
.agree-page {
  padding-top: 36px;
}
.select-div + .select-div {
  margin-top: 12px;
}
.select-bottom {
  font-size: 14px;
  margin-top: 12px;
}
.checkbox-container {
  margin-top: 12px;
  display: flex;
  align-items: center;
}

.custom-checkbox {
  -webkit-appearance: auto;
  border: 1px solid #E5E5E5;
  background: #FFF;
  width: 20px; /* 체크박스 크기 조정 */
  height: 20px; /* 체크박스 크기 조정 */
  cursor: pointer;
}

.custom-label {
  margin-left: 8px; /* 레이블과 체크박스 간격 조정 */
  cursor: pointer; /* 레이블 클릭 시 체크박스 선택 가능 */
}
@media (max-width: 1100px) {
  .select-bottom {
    font-size: 13px;
  }
}
.custom-checkbox:disabled,
.select-box:disabled {
  cursor: not-allowed;
}
.select-style[type=radio]:disabled {
  background-color: #F6F6F6;
  border: 5px solid #F6F6F6;
  cursor: not-allowed;
}
.text-area.w100 {
  width: 100%;
}
.agree-page.price .agree-div .item-ul li .title {
  margin-bottom: 15px;
}
.agree-page.price .agree-btm {
  margin-top: 15px;
  text-align: right;
}
.form-input {
  padding-top: 36px;
}
@media (max-width: 1100px) {
  #naju {
    margin-top: 10px;
  }
  .naju {
    position: relative;
    top: 5px;
  }
  .form-input {
    padding-top: 44px;
  }
}
</style>
